module.exports = __webpack_public_path__ + "img/wifi-test2-active.01664d9.png";